import Swal from 'sweetalert2';

export const catchErros = error => {
  if (error.response.data.field && error.response.data.fields[0]) {
    Swal.fire({
      title: 'Atenção',
      text: `${String(
        error.response.data.fields[0].parameter
      ).toUpperCase()}: ${error.response.data.fields[0].exception}`,
      icon: 'error',
      confirmButtonColor: '#74a50a',
    });
  } else {
    Swal.fire({
      title: 'Atenção',
      text: ` ${error.response.data.error}`,
      icon: 'error',
      confirmButtonColor: '#74a50a',
    });
  }
};
